import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { useStateValue } from '../context/stateContext';
import { Image, Dropdown, Message } from 'semantic-ui-react';
import { login, logout } from '../context/actions';
import { getApiErrorMessage } from '../utility/apiError';

const Login = () => {
  const [{ loggedUser }, dispatch] = useStateValue();
  const [loginError, setLoginError] = useState('');

  const onLoginSuccess = async ({ credential }) => {
    setLoginError('');

    try {
      const profileObject = jwtDecode(credential);

      const userData = {
        isLoggedIn: true,
        googleId: profileObject.sub,
        name: profileObject.name,
        token: credential,
        imageUrl: profileObject.picture,
        email: profileObject.email,
      };

      dispatch(await login(userData));
    } catch (error) {
      setLoginError(
        getApiErrorMessage(error, {
          context: 'login',
          fallback: 'Prijava putem Googlea nije uspjela. Pokušajte ponovo.',
        }),
      );
    }
  };

  const onLoginError = (googleEvent) => {
    console.error(JSON.stringify(googleEvent));
    setLoginError('Prijava putem Googlea nije uspjela. Pokušajte ponovo.');
  };

  const trigger = <Image avatar src={loggedUser.imageUrl} />;

  const option = [
    {
      key: 'sign-out',
      text: 'Odjavi se',
      icon: 'sign out',
      onClick: () => dispatch(logout()),
    },
  ];

  return (
    <>
      {!loggedUser.isLoggedIn ? (
        <>
          {loginError && <Message negative size="mini" content={loginError} />}
          <GoogleLogin
            shape="circle"
            outline="filled_blue"
            text="signin"
            locale="bs"
            width="50"
            onSuccess={onLoginSuccess}
            onError={onLoginError}
          />
        </>
      ) : (
        <Dropdown
          trigger={trigger}
          options={option}
          pointing="top right"
          icon={null}
          className="logout-dropdown"
        />
      )}
    </>
  );
};

export default Login;
